import { IModelDataV1, Model } from '@df/catalog/model';

export interface IRating {
    rating: number;
    count: number;
}

export interface IReviewData extends IModelDataV1<string | number>, IRating {
    author?: string;
    date?: string;
    title?: string;
    content?: string;
    replies?: IReviewReply[];
}

export interface IReviewReply {
    message: string;
    created_at?: string;
    author_type?: 'consumer' | 'businessUser';
}

/**
 * Review model representing magento review
 */
export class Review extends Model<IReviewData> {
    /**
     * Object type id
     * @type {String}
     */
    static override type = 'review';
}
